export class SurveyInformation {
  'hhg3080SurveyId'?: number;
  'surveyNumber'?: string;
  'carrierId'?: number;
  'agencyCode'?: string;
  'shipmentGrpIdentifier'?: number;
  'tspContactFname'?: string;
  'tspContactLname'?: string;
  'tspContactMi'?: string;
  'tspContactEmail'?: string;
  'tspContactPhone'?: number;
  'tspContactPhoneExt'?: number;
  'pickupDate'?: Date;
  'deliveryDate'?: Date;
  'faicCode'?: number;
  'agencyBureauName'?: string;
  'bolNumber'?: number;
  'shipmentType'?: string;
  'bolType'?: string;
  'tmssBol'?: number;
  'employeeFname'?: string;
  'employeeLname'?: string;
  'employeeMi'?: string;
  'employeeEmail'?: string;
  'employeePhone'?: number;
  'employeePhoneExt'?: number;
  'originZipId'?: number;
  'originCity'?: string;
  'originCountryId'?: number;
  'destinationZipId'?: number;
  'destinationCity'?: string;
  'destinationCountryId'?: number;
  'amcFname'?: string;
  'amcLname'?: string;
  'amcMi'?: string;
  'amcEmail'?: string;
  'amcPhone'?: number;
  'amcPhoneExt'?: number;
  'amcModificationRequest'?: number;
  'amcModificationComments'?: string;
  'adminComments'?: string;
  'emailSent'?: number;
  'emailSentDate'?: Date;
  'reminderCount'?: number;
  'reminderDate'?: Date;
  'status'?: string;
  'scac'?: string;
  'uniqueEmployeeIdentifier'?: any;
  'organizationId'?: any;
  'updateProgram'?: string;
  'updateId'?: number;
  'updateDate'?: Date;
  'createdDate'?: Date;
  'employeeUniqueId'?: string;
  'hhg3080ResponseEntity'?: {
    'qualityOfPacking'?: number,
    'damageToItems'?: number,
    'courtesyWorkers'?: number,
    'delivPickupOnTime'?: number,
    'clearCommunication'?: number,
    'responsiveInProblems'?: number,
    'overallQualityService'?: number,
    'commentsRemarks'?: string
  };
}


